import React from 'react';
import logo from '../../images/logo-iceberg.svg';

const Logo = () => {
  return <img src={logo} alt="Iceberg Logo" />;
};

export default Logo;
